/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import {
  ListSkillFeedbackResult,
  ListSkillFeedbackResult$inboundSchema,
} from "../components/listskillfeedbackresult.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListSkillFeedbackSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListSkillFeedbackSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListSkillFeedbackSecurity = {
  option1?: ListSkillFeedbackSecurityOption1 | undefined;
  option2?: ListSkillFeedbackSecurityOption2 | undefined;
};

export type ListSkillFeedbackRequest = {
  /**
   * The skill ID.
   */
  id: string;
  /**
   * Cursor for the next page of feedback.
   */
  cursor?: string | undefined;
  /**
   * The number of feedback rows to return per page.
   */
  limit?: number | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

export type ListSkillFeedbackResponse = {
  result: ListSkillFeedbackResult;
};

/** @internal */
export type ListSkillFeedbackSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListSkillFeedbackSecurityOption1$outboundSchema: z.ZodMiniType<
  ListSkillFeedbackSecurityOption1$Outbound,
  ListSkillFeedbackSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listSkillFeedbackSecurityOption1ToJSON(
  listSkillFeedbackSecurityOption1: ListSkillFeedbackSecurityOption1,
): string {
  return JSON.stringify(
    ListSkillFeedbackSecurityOption1$outboundSchema.parse(
      listSkillFeedbackSecurityOption1,
    ),
  );
}

/** @internal */
export type ListSkillFeedbackSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListSkillFeedbackSecurityOption2$outboundSchema: z.ZodMiniType<
  ListSkillFeedbackSecurityOption2$Outbound,
  ListSkillFeedbackSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function listSkillFeedbackSecurityOption2ToJSON(
  listSkillFeedbackSecurityOption2: ListSkillFeedbackSecurityOption2,
): string {
  return JSON.stringify(
    ListSkillFeedbackSecurityOption2$outboundSchema.parse(
      listSkillFeedbackSecurityOption2,
    ),
  );
}

/** @internal */
export type ListSkillFeedbackSecurity$Outbound = {
  Option1?: ListSkillFeedbackSecurityOption1$Outbound | undefined;
  Option2?: ListSkillFeedbackSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListSkillFeedbackSecurity$outboundSchema: z.ZodMiniType<
  ListSkillFeedbackSecurity$Outbound,
  ListSkillFeedbackSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListSkillFeedbackSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListSkillFeedbackSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listSkillFeedbackSecurityToJSON(
  listSkillFeedbackSecurity: ListSkillFeedbackSecurity,
): string {
  return JSON.stringify(
    ListSkillFeedbackSecurity$outboundSchema.parse(listSkillFeedbackSecurity),
  );
}

/** @internal */
export type ListSkillFeedbackRequest$Outbound = {
  id: string;
  cursor?: string | undefined;
  limit: number;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListSkillFeedbackRequest$outboundSchema: z.ZodMiniType<
  ListSkillFeedbackRequest$Outbound,
  ListSkillFeedbackRequest
> = z.pipe(
  z.object({
    id: z.string(),
    cursor: z.optional(z.string()),
    limit: z._default(z.int(), 20),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function listSkillFeedbackRequestToJSON(
  listSkillFeedbackRequest: ListSkillFeedbackRequest,
): string {
  return JSON.stringify(
    ListSkillFeedbackRequest$outboundSchema.parse(listSkillFeedbackRequest),
  );
}

/** @internal */
export const ListSkillFeedbackResponse$inboundSchema: z.ZodMiniType<
  ListSkillFeedbackResponse,
  unknown
> = z.pipe(
  z.object({
    Result: ListSkillFeedbackResult$inboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      "Result": "result",
    });
  }),
);

export function listSkillFeedbackResponseFromJSON(
  jsonString: string,
): SafeParseResult<ListSkillFeedbackResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListSkillFeedbackResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListSkillFeedbackResponse' from JSON`,
  );
}
